import React from 'react';
import { Content } from 'reactjs-admin-lte';
import CustomerCreateForm from './CustomerCreateForm';


const CustomerCreate = (props) => {
  return (
    <Content.Body>
      <CustomerCreateForm {...props} />
    </Content.Body>
  );
}

export default CustomerCreate;